import { sanitizeEmailHtml, type SanitizedEmail } from '@/lib/emailHtmlSanitizer';

export interface SanitizeOptions {
  showRemoteImages: boolean;
}

export function sanitizeMessageHtml(
  html: string,
  cidMap: Record<string, string>,
  { showRemoteImages }: SanitizeOptions,
): SanitizedEmail {
  const clean = sanitizeEmailHtml(html, {
    allowDataAttr: true,
  });

  let body = replaceCidReferences(clean.body, cidMap);
  body = showRemoteImages ? restoreRemoteImages(body) : stripRemoteImages(body);

  return { ...clean, body };
}

function escapeRegExp(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function replaceCidReferences(html: string, cidMap: Record<string, string>): string {
  let result = html;
  Object.entries(cidMap).forEach(([cid, dataUrl]) => {
    result = result.replace(new RegExp(`cid:${escapeRegExp(cid)}`, 'gi'), dataUrl);
  });
  return result;
}

function stripRemoteImages(html: string): string {
  return html.replace(
    /<img([^>]*?)src=["'](https?:\/\/[^"']+)["']([^>]*?)>/gi,
    (_match, before, src, after) => {
      return `<img${before}data-blocked-src="${src}" style="display:none"${after}>`;
    },
  );
}

function restoreRemoteImages(html: string): string {
  return html.replace(
    /<img([^>]*?)data-blocked-src=["']([^"']+)["']([^>]*?)>/gi,
    (_match, before, src, after) => {
      const cleanedBefore = before.replace(/\s*style=["'][^"']*display:\s*none[^"']*["']\s*/gi, '');
      const cleanedAfter = after.replace(/\s*style=["'][^"']*display:\s*none[^"']*["']\s*/gi, '');
      return `<img${cleanedBefore}src="${src}"${cleanedAfter}>`;
    },
  );
}
